import { FC } from "react"
import { Box, Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { OfferDetailsType } from "../../../../../../modules/merchant/admin/products/productsTypes"
import { LocalizedStrict } from "../../../../../../modules/localization/components/AppLocalized"

type StyleProps = Readonly<{
    top?: string
    right?: string
}>

type OnlyXLeftTagProps = StyleProps & {
    amount?: number
}

const useStyles = makeStyles<StyleProps>()((theme, { top, right }) => ({
    container: {
        ...(top || right ? { position: "absolute" as const, top, right } : {}),
    },
    tag: {
        padding: `0 0.375rem`,
        fontSize: "0.75rem",
        color: theme.palette.common.white,
        backgroundColor: theme.palette.common.black,
        border: `1px solid ${theme.palette.common.black}`,
        borderRadius: "0.25rem",
        whiteSpace: "nowrap",
    },
}))

export const OnlyXLeftTag: FC<OnlyXLeftTagProps> = ({ amount, top, right }) => {
    const { classes } = useStyles({ top, right })

    if (!amount) return null

    return (
        <Box className={classes.container}>
            <Box className={classes.tag}>
                <LocalizedStrict id="offer-tag-limited-on-sale" vars={{ amount }}>
                    <Typography variant="caption">Only {amount} left</Typography>
                </LocalizedStrict>
            </Box>
        </Box>
    )
}
